import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import "../styles/Navbar.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="logo-container" onClick={() => window.location.href = '/'}>
        <img src={logo} alt="EncryptArx Logo" className="logo-img" />
      </div>
      <ul ref={menuRef} className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            onClick={toggleMenu}
          >
            About Us
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/services"
            className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            onClick={toggleMenu}
          >
            Services
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/resources"
            className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            onClick={toggleMenu}
          >
            Resources
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/products"
            className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            onClick={toggleMenu}
          >
            Product
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            onClick={toggleMenu}
          >
            Contact Us
          </NavLink>
        </li>
      </ul>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? '✖' : '☰'}
      </button>
    </nav>
  );
};

export default Navbar;
